import { __decorate } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

let UiCCreditCardDisplayComponent = class UiCCreditCardDisplayComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input()
], UiCCreditCardDisplayComponent.prototype, "numberCard", void 0);
__decorate([
    Input()
], UiCCreditCardDisplayComponent.prototype, "nameCard", void 0);
__decorate([
    Input()
], UiCCreditCardDisplayComponent.prototype, "validityYear", void 0);
__decorate([
    Input()
], UiCCreditCardDisplayComponent.prototype, "validityMonth", void 0);
__decorate([
    Input()
], UiCCreditCardDisplayComponent.prototype, "imagePath", void 0);
__decorate([
    Input()
], UiCCreditCardDisplayComponent.prototype, "validityComplete", void 0);
UiCCreditCardDisplayComponent = __decorate([
    Component({
        selector: 'ui-c-credit-card-display',
        template: "<ion-card class=\"d-flex flex-column justify-content-around credit-card-display\">\n  <ion-grid class=\"pb-4\">\n    <ion-row class=\"h100\">\n      <ion-col class=\"h100 d-flex flex-column justify-content-end\" size=\"9\">\n        <ion-row class=\"card-code-data d-flex justify-content-between align-items-center\">\n         \n            <span>{{ numberCard.slice(0, 4) || 'XXXX' }}</span>\n            <span>{{ numberCard.slice(4, 8) || 'XXXX' }}</span>\n            <span>{{ numberCard.slice(8, 12) || 'XXXX' }}</span>\n            <span>{{ numberCard.slice(12, 16) || 'XXXX' }}</span>\n          \n          <p class=\"d-flex flex-column validity-date\">\n            <span class=\"validity-title\">Validade</span>\n            <span class=\"validity-date-number\">\n              <span *ngIf=\"validityMonth || validityYear \">\n                {{ (validityMonth || 'MM') + ' / ' + (validityYear.slice(2) || 'AAAA') }}\n              </span>\n              <span *ngIf=\"validityComplete\">\n                {{ validityComplete }}\n              </span>\n            </span>\n          </p>\n        </ion-row>\n        <ion-row class=\"card-person-name d-flex justify-content-start\">\n          <span>\n            {{ nameCard || 'Nome impresso no cart\u00E3o' }}\n          </span>\n        </ion-row>\n      </ion-col>\n      <ion-col class=\"h100 d-flex flex-column justify-content-end\" offset=\"1\" size=\"2\">\n        <ion-img *ngIf=\"!!imagePath\" [src]=\"imagePath\"></ion-img>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-card>\n",
        styles: [""]
    })
], UiCCreditCardDisplayComponent);

let UiCCreditCardDisplayModule = class UiCCreditCardDisplayModule {
};
UiCCreditCardDisplayModule = __decorate([
    NgModule({
        declarations: [UiCCreditCardDisplayComponent],
        imports: [
            IonicModule,
            ReactiveFormsModule,
            CommonModule
        ],
        exports: [
            UiCCreditCardDisplayComponent
        ]
    })
], UiCCreditCardDisplayModule);

/*
 * Public API Surface of ui-c-credit-card-display
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCCreditCardDisplayComponent, UiCCreditCardDisplayModule };
//# sourceMappingURL=wlp-ui-c-credit-card-display.js.map
